'use client'

import Image from 'next/image'
import type { PropsWithChildren } from 'react'

import { getAssetUrl } from '@mntn-dev/app-assets'
import {
  FocusedLayoutHeader,
  FocusedLayoutMain,
  FocusedLayout as UIFocusedLayout,
} from '@mntn-dev/ui-components/focused-layout'

export const FocusedLayout = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <UIFocusedLayout className={className}>
      <FocusedLayoutHeader>
        <Image
          className="drop-shadow-blur"
          src={getAssetUrl('quickframe-marketplace-logo-inline')}
          alt=""
          width={440}
          height={36}
        />
      </FocusedLayoutHeader>
      <FocusedLayoutMain>{children}</FocusedLayoutMain>
    </UIFocusedLayout>
  )
}
